import {useAuth} from "react-oidc-context";
import {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {Company} from "../entities/company";
import {CompaniesTable} from "../components/CompaniesTable";
import {CompanyCreateDialog} from "../components/CompanyCreateDialog";
import {CompanyCreateDto} from "../entities/company-create-dto";
import {Button, Card, CardHeader} from "@mui/material";
import {useSnackbar} from "notistack";
import {CompanyWithTokenRequestsCount} from "../entities/company-with-token-requests-count";

export const CompaniesPage = () => {
    const auth = useAuth();
    const {enqueueSnackbar} = useSnackbar();
    const navigate = useNavigate();
    const [companies, setCompanies] = useState<CompanyWithTokenRequestsCount[]>([]);
    const [isNewCompanyModalOpened, setIsNewCompanyModalOpened] = useState(false);

    const newCompanyModalOnClose = (companyCreate?: CompanyCreateDto) => {
        if (!companyCreate) {
            setIsNewCompanyModalOpened(false);
        } else {
            fetch("/api/admin/companies", {
                method: "POST",
                headers: {"Content-Type": "application/json", "Authorization": `Bearer ${auth?.user?.access_token}`},
                body: JSON.stringify(companyCreate)
            }).then((res) => {
                if (res.status === 201) {
                    enqueueSnackbar("Company created successfully.", {variant: "success"});
                    if (res.headers.has("Location")) {
                        const url = new URL(res.headers.get("Location")!!);
                        const pathParts = url.pathname.split('/');
                        const id = pathParts[pathParts.length - 1];

                        navigate(`./${id}`);
                    }
                } else {
                    throw Error(`Unable to create company - ${res.status}`);
                }
            }).catch((err) => {
                enqueueSnackbar(`Error creating company ${err?.message}`, {variant: "error"});
            })
            setIsNewCompanyModalOpened(false);

        }
    }

    useEffect(() => {
        if (auth.isAuthenticated) {
            const token = auth.user?.access_token;
            fetch("/api/admin/companies", {headers: {"Authorization": `Bearer ${token}`}})
                .then(res => res.json())
                .then(data => setCompanies(data))
                .catch(error => console.log(error));
        }
    }, [auth.isAuthenticated, auth.user?.access_token]);

    const onCompanyClick = (company: Company) => {
        navigate(`./${company.id}`, {state: company})
    }

    return (<>

        <Card>
            <CardHeader
                title={<Button onClick={() => setIsNewCompanyModalOpened(true)} variant="outlined">Add company</Button>}></CardHeader>
            <CompaniesTable onCompanyClick={onCompanyClick} companies={companies}
                            showTokenCount={true}></CompaniesTable>
        </Card>
        {isNewCompanyModalOpened &&
            <CompanyCreateDialog isOpen={isNewCompanyModalOpened} onClose={newCompanyModalOnClose}/>}
    </>)
}